'use strict';

var React = require('react');

var SvgMonerisMajor = function SvgMonerisMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.541 0a1.5 1.5 0 0 0-1.5 1.54l.013.46h15.892l.012-.46a1.5 1.5 0 0 0-1.5-1.54h-12.916z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.424 20a1.5 1.5 0 0 1-1.498-1.422l-.76-14.578h15.669l-.76 14.578a1.5 1.5 0 0 1-1.5 1.422h-11.151zm.576-14h10v4h-10v-4zm0 6h2v2h-2v-2zm0 4h2v2h-2v-2zm6-4h-2v2h2v-2zm-2 4h2v2h-2v-2zm6-4h-2v2h2v-2zm-2 4h2v2h-2v-2z"
  }));
};

exports.SvgMonerisMajor = SvgMonerisMajor;
